'use client';
import { LogOut, Bell, User, MessageSquare } from 'lucide-react';
import Link from 'next/link';
import { useState, useEffect } from 'react';

export default function LogoutButton() {
  const [username, setUsername] = useState('Guest');
  const [notifications, setNotifications] = useState<any[]>([]);
  const [showBell, setShowBell] = useState(false);

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const u = JSON.parse(userStr);
        setUsername(u.username || 'User');
      } catch(e){}
    }

    // Fetch notifications
    fetch('/api/notifications')
      .then(r => r.json())
      .then(d => {
        if (d.success && d.data) {
          setNotifications(d.data);
        }
      })
      .catch(e => console.error(e));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <div className="mt-2 flex flex-col gap-2">
      <div className="flex items-center justify-between px-3 py-2 bg-slate-950/50 rounded-lg border border-slate-800">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center text-slate-400">
            <User size={16} />
          </div>
          <span className="text-sm font-medium text-slate-300">{username}</span>
        </div>
        
        <div className="flex items-center gap-1">
          <Link
            href="/chat"
            className="p-1.5 text-slate-400 hover:text-purple-400 hover:bg-slate-800 rounded-full transition relative"
            title="แชท & สื่อสารทีม"
          >
            <MessageSquare size={18} />
          </Link>
          <div className="relative">
            <button 
              onClick={() => setShowBell(!showBell)}
            className="p-1.5 text-slate-400 hover:text-amber-400 hover:bg-slate-800 rounded-full transition relative"
          >
            <Bell size={18} />
            {notifications.length > 0 && (
              <span className="absolute 0 right-0 w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
            )}
            {notifications.length > 0 && (
              <span className="absolute 0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
            )}
          </button>
        </div>

          {showBell && (
            <div className="absolute bottom-10 left-0 w-72 bg-slate-900 border border-slate-700 rounded-xl shadow-2xl z-50 overflow-hidden animate-in fade-in slide-in-from-bottom-2">
              <div className="p-3 border-b border-slate-800 bg-slate-800/50 flex justify-between items-center">
                <span className="font-semibold text-white text-sm">การแจ้งเตือน ({notifications.length})</span>
                <button onClick={() => setShowBell(false)} className="text-slate-400 hover:text-white">&times;</button>
              </div>
              <div className="max-h-64 overflow-y-auto">
                {notifications.length === 0 ? (
                  <div className="p-4 text-center text-sm text-slate-500">ไม่มีการแจ้งเตือนใหม่</div>
                ) : (
                  notifications.map((n, i) => (
                    <div key={i} className="p-3 border-b border-slate-800/50 hover:bg-slate-800/50 transition">
                      <div className={`text-xs font-semibold mb-1 ${n.type === 'overdue' ? 'text-red-400' : 'text-amber-400'}`}>{n.title}</div>
                      <div className="text-xs text-slate-300 leading-relaxed">{n.message}</div>
                      <div className="text-[10px] text-slate-500 mt-1">{n.time}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <button 
        onClick={handleLogout} 
        className="w-full flex items-center gap-3 px-3 py-2 hover:bg-red-900/30 text-red-400 rounded-lg transition text-sm"
      >
        <LogOut size={16} /> ออกจากระบบ
      </button>
    </div>
  );
}
